import { Anchor, Button, Checkbox, Group, Stack, Text, Title } from "@mantine/core";
import { useState } from "react";
import { terms_of_uses_path } from "../../routes";

type SignModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  documentTitle: string;
  disabled?: boolean;
};

export function SignModal({ onClose, onConfirm, documentTitle, disabled = false }: SignModalProps) {
  const [checked, setChecked] = useState(false);

  return (
    <Stack>
      <Title order={3}>Dokument {documentTitle} signieren</Title>
      <Checkbox
        checked={checked}
        onChange={(event) => setChecked(event.currentTarget.checked)}
        label={
          <Text>
            Mit dem Signieren erkläre ich mich mit den{" "}
            <Anchor href={terms_of_uses_path()} target="_blank">
              Nutzungsbedingungen
            </Anchor>{" "}
            einverstanden.
          </Text>
        }
      />
      <Text fw="700">Dieses Dokument wird hiermit digital und rechtsverbindlich signiert.</Text>
      <Group>
        <Button variant="default" color="grey" flex={1} onClick={onClose}>
          Abbrechen
        </Button>
        <Button flex={1} onClick={onConfirm} disabled={disabled || !checked}>
          Signieren
        </Button>
      </Group>
    </Stack>
  );
}
